import request from '@/util/request'
import qs from 'qs'

export function listLanguage(){
  return request({
    url : "/api-basis/basis/language/list",
    method : "get"
  });
}

export function getLanguagePackage(languagecode){
  return request({
    url : "/api-basis/basislangukeyword/languKeyWordByLanguage/" + languagecode,
    method : "get"
  });
}


// WEBPACK FOOTER //
// ./src/api/language.js